import { setSiteDetailsData } from '../../../redux/siteDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { EditSiteRelation } from '../editSite/editSiteRelation';
import { AddSiteRelation } from '../editSite/addSiteRelation';
import { Box, Typography, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteRecord } from '../../deleteRecord';
import NullDataBox from '../../nullDataBox';
import Iconify from '../../Iconify';
import { useState } from 'react';
import axios from 'axios';
import '../../../css/sites/polesMetiersRelated.css';

const PolesMetiersRelated = () => {

    const dispatch = useDispatch();
    const siteDetailsData = useSelector((state) => state.SiteDetailsData);
    const hasSiteUpdatePermission = useHasPermission('site_update');

    const [openAddRelation, setOpenAddRelation] = useState(false);
    const [relationToDelete, setRelationToDelete] = useState(null);
    const [openDeleteRelation, setOpenDeleteRelation] = useState(false);
    const [editRelation, setEditRelation] = useState({ relationData: null, open: false });

    const openDeleteRelationDialog = (pole_id) => {
        setRelationToDelete(pole_id);
        setOpenDeleteRelation(true);
    }

    const handleDeleteRelation = async () => {
        try {
            const response = await axios.delete(`site-pole-metier/${siteDetailsData.id}/${relationToDelete}`);
            if (response.status === 200 || response.status === 201) {
                setOpenDeleteRelation(false);
                dispatch(setSiteDetailsData({
                    ...siteDetailsData,
                    site_pole_metier: siteDetailsData?.site_pole_metier?.filter(
                        (relation) => relation?.pole?.id !== relationToDelete // Filter by pole.id
                    ),
                }));
            }
        } catch (error) {
            console.error('Error deleting site relation:', error);
            CustomErrorLogger(error, "Delete Site Relation");
        }
    };

    const groupedData = siteDetailsData?.site_pole_metier.reduce((acc, relation) => {
        const poleId = relation?.pole?.id;
        const poleName = relation?.pole?.name;
        const metierId = relation?.metier?.id;
        const metierName = relation?.metier?.name;

        // Check if the pole already exists in the accumulator
        let pole = acc?.find((item) => item?.pole_id === poleId);

        if (!pole) {
            // If the pole doesn't exist, add it with an empty metier array
            pole = { pole_id: poleId, pole_name: poleName, metier: [] };
            acc?.push(pole);
        }

        // Add the metier to the pole's metier array
        pole?.metier?.push({ metier_id: metierId, metier_name: metierName });

        return acc;
    }, []);

    return (
        <Box className='siteRelations_box'>
            <Box className='siteRelations_edit_box'>
                <Typography className='siteRelations_title'>Pôles et métiers associées</Typography>
                {hasSiteUpdatePermission && siteDetailsData?.site_pole_metier?.length > 0 &&
                    <Typography className='siteRelations_relation_ajouter' onClick={() => setOpenAddRelation(true)}> + Ajouter un pôle et des métiers</Typography>
                }
            </Box>

            {siteDetailsData?.site_pole_metier?.length === 0 ?
                <NullDataBox
                    setOpenDialog={setOpenAddRelation}
                    buttonTitle="Ajouter pôles et métiers de site"
                    description="Sélectionnez les pôles et les métiers associées à ce site."
                />
                :
                <Box className='siteRelations_details_actions_box'>
                    {groupedData && groupedData?.map(({ pole_id, pole_name, metier }) => (
                        <Box key={pole_id} className='siteRelations_details_oneRelation_box'>
                            <Grid container>
                                {/* First Column: Pôle */}
                                <Grid item xs={12} sm={3} className='siteRelations_icon_title_response_box'>
                                    <Iconify icon="uil:building" width="32px" />
                                    <Box className='siteRelations_response_box'>
                                        <Typography className='siteRelations_text_label'>Pôle :</Typography>
                                        <Typography className='siteRelations_text_value'>{pole_name}</Typography>
                                    </Box>
                                </Grid>

                                {/* Second Column: Métiers */}
                                <Grid item xs={12} sm={9} className='siteRelations_icon_title_response_box'>
                                    <Iconify icon="streamline-plump:bag-suitcase-4" width="32px" />
                                    <Box className='siteRelations_response_box'>
                                        <Typography className='siteRelations_text_label'>Métiers :</Typography>
                                        <Typography className='siteRelations_text_value'>
                                            {metier?.map(({ metier_name }) => metier_name)?.join(', ')}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            {hasSiteUpdatePermission && (
                                <Box className='siteRelations_relation_actions_box'>
                                    <Iconify
                                        className='siteRelations_action_icon'
                                        icon={"ic:outline-delete"}
                                        onClick={() => openDeleteRelationDialog(pole_id)}
                                    />
                                    <Iconify
                                        className='siteRelations_action_icon'
                                        icon={"ic:outline-edit"}
                                        onClick={() => setEditRelation({ relationData: { pole_id, pole_name, metier }, open: true })}
                                    />
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            }

            {openAddRelation &&
                <AddSiteRelation setOpenAddRelation={setOpenAddRelation} openAddRelation={openAddRelation} site_id={siteDetailsData.id} />
            }

            {editRelation.open &&
                <EditSiteRelation editRelation={editRelation} setEditRelation={setEditRelation} site_id={siteDetailsData.id} />
            }

            {openDeleteRelation &&
                <DeleteRecord
                    openDelete={openDeleteRelation}
                    setOpenDelete={setOpenDeleteRelation}
                    handleDelete={handleDeleteRelation}
                    title="Êtes-vous sûr du vouloir supprimer cette relation ?"
                />
            }

        </Box >

    );
}

export default PolesMetiersRelated;